import { useEffect } from 'react';
import { Grid, Typography } from '@mui/material';
import { useIntl } from 'react-intl';
import useWindowSize from '../hooks/useWindowResize';
import { useTheme } from '@mui/material/styles';
import useFetchWhatsAppNumbers from '../hooks/api/useFetchWhatsAppNumbers';
import { getPrefix } from '../global_func';
import { useLanguage } from '../LanguageContext';
import Skeleton from '../components/skeletons/Skeletons';
import InfoCard from '../components/Card/InfoCard';

const ContactUs = () => {
	const {
		$t,
		messages: {
			contactUsCards: {
				rajabGazaqh,
				safarAraghbai,
				ehsanVakili,
				asefNazerian,
				boranBayeva,
				berdinazarOvezov,
				abdazizSakhi,
				hamedAbbasi,
			},
		},
	} = useIntl();
	const { locale } = useLanguage();
	const { width } = useWindowSize();
	const theme = useTheme();

 	const contactPeople = [
 		{
 			name: rajabGazaqh.name,
 			logo: '/assets/Images/logos/AltynGroup.png',
 			logoAlt: 'Altyn Group',
 			countryFlag: '/assets/Images/flags/Iran.png',
 			languages: rajabGazaqh.languages,
 			profileImg: '/assets/Images/profiles/AltynGroupCEO.png',
 			profileImgAlt: 'Rajab Ghazagh',
 			mobile: '989381929524',
 			extra: rajabGazaqh.extra,
 		},
 		{
 			name: safarAraghbai.name,
 			role: safarAraghbai.role,
 			logo: '/assets/Images/logos/AltynRail.jpg',
 			logoAlt: 'Altyn Rail',
 			countryFlag: '/assets/Images/flags/Iran.png',
 			languages: safarAraghbai.languages,
 			profileImg: '/assets/Images/profiles/SaparAriqbay.png',
 			profileImgAlt: 'Safar Araghbai',
 			mobile: '989032218538',
 			location: safarAraghbai.location,
 			description: safarAraghbai.description,
 		},
 		{
 			name: ehsanVakili.name,
 			role: ehsanVakili.role,
 			logo: '/assets/Images/logos/AltynMiras.jpeg',
 			logoAlt: 'Altyn Miras',
 			countryFlag: '/assets/Images/flags/Iran.png',
 			languages: ehsanVakili.languages,
 			profileImg: '/assets/Images/profiles/EhsanVakili.jpg',
 			profileImgAlt: 'Ehsan Vakili',
 			mobile: '989025313535',
 			location: ehsanVakili.location,
 			description: ehsanVakili.description,
 		},
 		{
 			name: asefNazerian.name,
 			role: asefNazerian.role,
 			logo: '/assets/Images/logos/AltynSareban.png',
 			logoAlt: 'Altyn Sareban',
 			countryFlag: '/assets/Images/flags/Iran.png',
 			languages: asefNazerian.languages,
 			profileImg: '/assets/Images/profiles/AsefNazerian.png',
 			profileImgAlt: 'Asef Nazerian',
 			mobile: '989032218538',
 			location: asefNazerian.location,
 			description: asefNazerian.description,
 		},
 		{
 			name: boranBayeva.name,
 			role: boranBayeva.role,
 			logo: '/assets/Images/logos/AltynLogisticKZ.png',
 			logoAlt: 'Altyn Logistic KZ',
 			countryFlag: '/assets/Images/flags/Kazakhstan.png',
 			languages: boranBayeva.languages,
 			profileImg: '/assets/Images/profiles/BoranbayevaGulnaraZharylkasynovna.jpg',
 			profileImgAlt: 'Boranbayeva Gulnara Zharylkasynovna',
 			mobile: '77015407993',
 			location: boranBayeva.location,
 			description: boranBayeva.description,
 		},
 		{
 			name: berdinazarOvezov.name,
 			role: berdinazarOvezov.role,
 			logo: '/assets/Images/logos/AltynHayat.png',
 			logoAlt: 'Altyn Hayat',
 			countryFlag: '/assets/Images/flags/Turkmenistan.png',
 			languages: berdinazarOvezov.languages,
 			profileImg: '/assets/Images/profiles/BerdinazarOvezov.jpg',
 			profileImgAlt: 'Berdinazar Ovezov',
 			mobile: '99363000136',
 			location: berdinazarOvezov.location,
 			description: berdinazarOvezov.description,
 		},
 		{
 			name: abdazizSakhi.name,
 			role: abdazizSakhi.role,
 			logo: '/assets/Images/logos/AltynAfghan.jpg',
 			logoAlt: 'Altyn Afghan',
 			countryFlag: '/assets/Images/flags/Afghanistan.jpg',
 			languages: abdazizSakhi.languages,
 			profileImg: '/assets/Images/profiles/AltynAfghanCEO.jpg',
 			profileImgAlt: 'Abdul aziz Sakhi',
 			mobile: '93749999117',
 			location: abdazizSakhi.location,
 			description: abdazizSakhi.description,
 		},
 		{
 			name: hamedAbbasi.name,
 			role: hamedAbbasi.role,
 			logo: '/assets/Images/logos/AltynTech.png',
 			logoAlt: 'Altyn Tech',
 			countryFlag: '/assets/Images/flags/Iran.png',
 			languages: hamedAbbasi.languages,
 			profileImg: '/assets/Images/profiles/HamedAbbasi.jpg',
 			profileImgAlt: 'Hamed Abbasi',
 			mobile: '989112738596',
 			location: hamedAbbasi.location,
 			description: hamedAbbasi.description,
 		},
 	];

	const { data: whatsAppNumbers, isLoading } = useFetchWhatsAppNumbers();

	useEffect(() => {
		if (window && window.addMap) window.addMap();
	}, []);

	return (
		<Grid
			display={'grid'}
			gap={'50px'}
			py={{ xs: '50px', md: '100px' }}
			px={{ xs: '10px', s: '3%', md: '5%', lg: '10%' }}
		>
			<Grid
				display={'grid'}
				gap={'40px'}
			>
				<Typography
					variant={'h3'}
					display={'flex'}
					justifyContent={'center'}
				>
					{$t({ id: 'contactUsPersonTitle' })}
				</Typography>
				<Grid
					display={'grid'}
					gridTemplateColumns={{
						xs: '1fr',
						s: 'repeat(2, 1fr)',
						lg: 'repeat(3, 1fr)',
					}}
					rowGap={'40px'}
					columnGap={width > theme.breakpoints.values.md ? '5%' : '3%'}
				>
					{contactPeople.map(
						(
							{
								name,
								role,
								logo,
								logoAlt,
								countryFlag,
								profileImg,
								profileImgAlt,
								mobile,
								email,
								location,
								extra,
							},
							index
						) => (
							<InfoCard
								key={index}
								{...{
									name,
									role,
									logo,
									logoAlt,
									countryFlag,
									profileImg,
									profileImgAlt,
									mobile,
									email,
									location,
									extra,
								}}
							/>
						)
					)}
				</Grid>
			</Grid>
			<Grid
				display={'grid'}
				gap={'40px'}
			>
				<Typography
					variant={'h3'}
					display={'flex'}
					justifyContent={'center'}
				>
					{$t({ id: 'contactUsNumberstitle' })}
				</Typography>
				<Grid
					display={'grid'}
					gridTemplateColumns={{
						xs: '1fr',
						md: 'repeat(2, 1fr)',
						// lg: 'max-content 1fr max-content',
					}}
					gap={'30px'}
				>
					<Grid
						className="card"
						display={'grid'}
						gap={'10px'}
						py={'16px'}
						px={'32px'}
					>
						<Grid>
							<Typography
								variant={'span'}
								fontSize={'16px'}
								fontWeight={500}
								color={theme.palette.info.one}
							>
								{$t({ id: 'PhoneNumbers' })}
							</Typography>
						</Grid>
						<Grid>
							{isLoading ? (
								<Grid
									display={'grid'}
									gap={'10px'}
								>
									<Skeleton />
									<Skeleton />
								</Grid>
							) : whatsAppNumbers ? (
								<div
									dangerouslySetInnerHTML={{
										__html: whatsAppNumbers
											? whatsAppNumbers['content_short' + getPrefix(locale)]
											: '',
									}}
								></div>
							) : (
								''
							)}
						</Grid>
					</Grid>
					{/* {width > theme.breakpoints.values.lg && <span></span>} */}
					<Grid
						className="card"
						display={'grid'}
						gap={'10px'}
						py={'16px'}
						px={'32px'}
					>
						<Grid
							display={'grid'}
							gap={'10px'}
							height={'max-content'}
						>
							<Typography
								fontSize={'16px'}
								color={theme.palette.info.one}
							>
								{$t({ id: 'EmailInputLabel' })}:
							</Typography>
							<Typography
								fontSize={'16px'}
								color={theme.palette.info.four}
								textAlign={'end'}
							>
								info@altynlogistics.com
							</Typography>
						</Grid>
						<Grid
							display={'grid'}
							gap={'10px'}
							height={'max-content'}
						>
							<Typography
								fontSize={'16px'}
								color={theme.palette.info.one}
							>
								{$t({ id: 'SocialMedia' })}:
							</Typography>
							<Grid
								display={'flex'}
								justifyContent={'end'}
								gap={'10px'}
							>
								<Grid
									display={'flex'}
									alignItems={'center'}
									gap={'10px'}
								>
									<Typography fontSize={'16px'}>altyn.logistics</Typography>
									<Grid className="img-box">
										<img
											src={'/assets/Images/SecondInstagram.svg'}
											alt={'Instagram'}
										/>
									</Grid>
								</Grid>
								<Grid
									display={'flex'}
									alignItems={'center'}
									gap={'10px'}
								>
									<Typography fontSize={'16px'}>altyn.logistics</Typography>
									<Grid className="img-box">
										<img
											src={'/assets/Images/Linkdin.svg'}
											alt={'Linkdin'}
										/>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<Grid
				display={'grid'}
				gap={'20px'}
			>
				<Typography
					fontSize={'16px'}
					fontWeight={500}
					color={'rgba(57, 55, 51, 1)'}
				>
					{$t({ id: 'mapLocation' })}
				</Typography>

				<Grid>
					<div id="osm-map"></div>
				</Grid>
			</Grid>
		</Grid>
	);
};

export default ContactUs;
